module.exports = __webpack_public_path__ + "assets/img/box5_cimg2.8c836ead.png";